import { useNavigate } from 'react-router-dom';
import {
  Landmark, BarChart2, Target, ShieldCheck, Calendar, FileText,
  CreditCard, Heart, Plane, Layers, Globe, Compass, ShoppingBag,
  HelpCircle, User, MessageCircle, LifeBuoy, History, Building2,
} from 'lucide-react';

// Mirrors mobile MoreScreen MENU_GROUPS exactly — same order, same groups
const MORE_GROUPS = [
  {
    label: 'EMI & Investments',
    items: [
      { label: 'EMIs',          path: '/emis',          icon: Landmark,    bg: '#eef2ff', color: '#6366f1' },
      { label: 'Investments',   path: '/investments',   icon: BarChart2,   bg: '#eff6ff', color: '#3b82f6' },
      { label: 'Goals',         path: '/savings-goals', icon: Target,      bg: '#ecfdf5', color: '#10b981' },
      { label: 'Insurance',     path: '/more',          icon: ShieldCheck, bg: '#ecfdf5', color: '#059669' },
    ],
  },
  {
    label: 'Manage',
    items: [
      { label: 'Calendar',          path: '/calendar',          icon: Calendar, bg: '#fff7ed', color: '#f97316' },
      { label: 'Statements',        path: '/data',              icon: FileText, bg: '#eff6ff', color: '#3b82f6' },
      { label: 'Historical Entry',  path: '/historical-entry',  icon: History,  bg: '#fdf4ff', color: '#9333ea' },
    ],
  },
  {
    label: 'Owe & Lend',
    items: [
      { label: 'Credit Cards',  path: '/credit-cards',  icon: CreditCard,  bg: '#fdf4ff', color: '#a855f7' },
      { label: 'Hand Loans',    path: '/hand-loans',    icon: Heart,       bg: '#ecfdf5', color: '#10b981' },
      // { label: 'Chit Funds',    path: '/chit-funds',    icon: Landmark,    bg: '#fff7ed', color: '#f97316' },
    ],
  },
  {
    label: 'Together',
    items: [
      { label: 'Trips',         path: '/trips',         icon: Plane,       bg: '#fff7ed', color: '#f97316' },
      { label: 'Group Spend',   path: '/group-expenses',icon: Layers,      bg: '#fffbeb', color: '#f59e0b' },
      { label: 'Family Circle', path: '/circle',        icon: Globe,       bg: '#fdf2f8', color: '#ec4899' },
    ],
  },
  {
    label: 'Tools',
    items: [
      { label: 'Insights',      path: '/insights',      icon: Compass,     bg: '#f0f9ff', color: '#0284c7' },
      // { label: 'Journeys',      path: '/journeys',      icon: Layers,      bg: '#fdf4ff', color: '#9333ea' },
      { label: 'Smart Buy',     path: '/smart-buy',     icon: ShoppingBag, bg: '#fff7ed', color: '#f97316' },
      { label: 'Quick Notes',   path: '/notes',         icon: FileText,    bg: '#fefce8', color: '#ca8a04' },
    ],
  },
  // { label: 'Life Events', items: [{ label: 'Build Tracker', path: '/build-tracker', icon: Building2, bg: '#f0f9ff', color: '#0284c7' }] },
  {
    label: 'Support',
    items: [
      { label: 'Help & Support',path: '/support',       icon: HelpCircle,  bg: '#fff7ed', color: '#f97316' },
    ],
  },
];

export default function MorePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-stone-50 dark:bg-stone-950">
      {/* Header */}
      <div className="bg-white dark:bg-stone-900 border-b border-stone-200 dark:border-stone-800 px-6 py-5">
        <h1 className="text-xl font-extrabold text-stone-900 dark:text-stone-100">More</h1>
        <p className="text-xs text-stone-400 mt-0.5">All features in one place</p>
      </div>

      <div className="px-4 py-5 space-y-6">
        {MORE_GROUPS.map((group) => (
          <div key={group.label}>
            <p className="text-[11px] font-bold tracking-widest text-orange-500 uppercase mb-3">
              {group.label}
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 sm:grid-cols-4 gap-3">
              {group.items.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.path + item.label}
                    onClick={() => navigate(item.path)}
                    className="flex flex-col items-center gap-2 p-3 rounded-2xl
                      bg-white dark:bg-stone-800 border border-stone-100 dark:border-stone-700
                      hover:shadow-md hover:-translate-y-0.5 transition-all duration-150 active:scale-95"
                  >
                    <div className="w-11 h-11 rounded-2xl flex items-center justify-center"
                      style={{ backgroundColor: item.bg }}>
                      <Icon size={20} style={{ color: item.color }} />
                    </div>
                    <span className="text-[11px] font-semibold text-stone-700 dark:text-stone-300 text-center leading-tight">
                      {item.label}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
